module.exports = __webpack_public_path__ + "static/media/3DPPA19.d9eec8a7.jpg";